
import {isCurrentRoute} from './navbar-defs.js'
import $profile from 'stores/profile'

const __default__ = {
  props: {
    items: {type: Array, default: () => []}
  },
  computed: {
    is_settings(){
      return this.$route.path === '/settings'
    },
    padding(){
      return this.$store.max_style ? '1.8rem 0.2rem 1.6rem' : '3.2rem 0.2rem 1.6rem'
    },
    profile(){
      return $profile
    }
  },
  methods: {
    isCurrentRoute(item){
      return isCurrentRoute(this.$route, item)
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "31dc0930-padding": (_ctx.padding)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__